<template lang="pug">
.container-modal-back(v-if="show" @click="onClose")
  .container-modal(:style="modalStyle" @click.stop="")
    .container-modal-header
      .container-modal-header__start(v-if="$slots.header")
        slot(name="header")
      img.modal-close-icon(:src="require('@/assets/times.svg')" alt="Cerrar" @click="onClose")
    .container-modal-body
      slot
</template>

<script>
export default {
  name: 'OrderActionModal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '36rem'
    }
  },

  computed: {
    modalStyle () {
      return { maxWidth: this.maxWidth }
    }
  },

  watch: {
    show (visible) {
      if (visible) {
        this.$nextTick(() => this.moveToBody())
      }
    }
  },

  mounted () {
    if (this.show) {
      this.moveToBody()
    }
  },

  destroyed () {
    this.removeFromBody()
  },

  methods: {
    moveToBody () {
      if (!this.$el || this.$el.nodeType !== 1) return
      if (this.$el.parentNode !== document.body) {
        document.body.appendChild(this.$el)
      }
    },

    removeFromBody () {
      if (this.$el && this.$el.nodeType === 1 && this.$el.parentNode === document.body) {
        document.body.removeChild(this.$el)
      }
    },

    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.container-modal-back
  position fixed
  top 0
  left 0
  width 100vw
  height 100vh
  height 100dvh
  padding 4rem 0
  box-sizing border-box
  background-color rgba(0, 0, 0, 0.5)
  z-index 12000
  display flex
  justify-content center
  align-items center

.container-modal
  background-color var(--background-principal, #fff)
  width calc(100% - 2rem)
  height 100%
  display flex
  flex-direction column
  overflow hidden
  cursor default

.container-modal-header
  display flex
  align-items center
  justify-content flex-end
  gap 1rem
  padding 1rem 1.5rem
  flex-shrink 0

.container-modal-body
  overflow-y auto
  min-height 0

.container-modal-header__start
  flex 1
  min-width 0
  margin-right 1rem

.modal-close-icon
  flex-shrink 0
  width 1.25rem
  height 1.25rem
  cursor pointer
  opacity .75

  &:hover
    opacity 1
</style>



// WEBPACK FOOTER //
// src/components/pages/order/refund/OrderActionModal.vue